import Button from '$partials/ui/button';
import React from 'react';
import { formatLinkBlockToUrl } from '$utilities/data';
import { SimpleImage } from '$partials/media/image-simple';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').HorizontalTextAndImage}
 */

const HorizontalTextAndImage = ({
    image,
    heading,
    body,
    ctaLabel,
    ctaLink
}) => {
    return (
        <div className='module-horizontal-text-and-image theme-light bg-main-background relative md:py-48 sm:py-40 py-24'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='col-wrapper flex md:flex-row sm:flex-col-reverse flex-col gap-y-24'>
                    <div className='md:w-4/12 col-padding flex flex-col gap-y-16'>
                        {heading &&
                            <h2 className='type-style-2 text-main-text-primary'>
                                {heading}
                            </h2>
                        }
                        {body &&
                            <div
                                className='type-style-body-r text-main-text-primary mt-4'>
                                {body}
                            </div>
                        }
                        {ctaLabel && ctaLink &&
                            <Button
                                as='a'
                                className='button-secondary-filled button-secondary-filled--small type-style-eyebrow w-max'
                                href={formatLinkBlockToUrl(ctaLink)}>
                                {ctaLabel}
                            </Button>
                        }
                    </div>
                    <div className='md:w-8/12 col-padding'>
                        <SimpleImage
                            {...image.image}
                            className='w-full h-full object-cover aspect-video'/>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default HorizontalTextAndImage;
